import { Outlet } from 'react-router';
import { AppLoader } from './AppLoader';
import { IAnalyticsAccessGate } from './types';

/**
 * The analytics pages wait for the analytics access (their guards read it); the rest of the app
 * doesn't: it no longer waits for that second request before showing anything.
 */
export const AnalyticsAccessGate = ({ isLoading }: IAnalyticsAccessGate) => (isLoading ? <AppLoader /> : <Outlet />);
